export enum OrderTransactionTypeEnum {
  GATEWAY_FEE="gateway_fee",
  DV_COMMISSION="dv_commission",
  DV_PROFIT="dv_profit",
  DV_DISCOUNT="dv_discount",
  ADVERTISER_PAYMENT="advertiser_payment",
  CUSTOMER_REFUND="customer_refund",
  INITIAL_AMT="initial_amt"
}